import React from "react";

const LogoGenially = () => {
  return (
    <svg width="5.5rem" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" data-testid="logoGenially">
      <g>
        <path
          d="M14.83 1v14.83L27.795 8.64C25.266 4.086 20.41 1 14.83 1z"
          fill="url(#f)"
        />
        <path
          d="M14.83 15.829l12.708 7.636c2.68-4.47 2.924-10.217.134-15.05l-12.843 7.414z"
          fill="url(#e)"
        />
        <path
          d="M14.57 30.653c5.211.086 10.311-2.576 13.102-7.41L14.829 15.83l-.259 14.824z"
          fill="url(#d)"
        />
        <path
          d="M1.862 23.017c2.531 4.556 7.387 7.641 12.967 7.641V15.83L1.862 23.017z"
          fill="url(#c)"
        />
        <path
          d="M1.987 23.244l12.842-7.415L2.121 8.193c-2.68 4.47-2.925 10.218-.134 15.05z"
          fill="url(#b)"
        />
        <path
          d="M1.987 8.415l12.842 7.414.259-14.823a14.714 14.714 0 00-.245-.003c-5.126 0-10.11 2.654-12.856 7.412z"
          fill="url(#a)"
        />
      </g>
      <path
        className="Logovariants__Path-sc-1y3h6v6-0 dTXGPN"
        d="m26.537 15.83c0 6.465-5.242 11.707-11.708 11.707s-11.707-5.243-11.707-11.708 5.241-11.707 11.707-11.707 11.707 5.241 11.707 11.707z"
        fill="#000F33"
      />
      <g className="Logovariants__G-sc-1y3h6v6-1 gZYeXr" fill="#fff">
        <path
          className="Logovariants__Path-sc-1y3h6v6-0 gWRYgn"
          d="M22.327 15.653c-.692 0-1.29.486-1.425 1.165a5.916 5.916 0 01-11.703-1.539c.186-3.026 2.704-5.454 5.735-5.538a5.903 5.903 0 012.116.327c.64.223 1.35-.013 1.694-.597l.062-.106a1.4 1.4 0 00-.75-2.028 8.806 8.806 0 00-3.27-.503c-4.589.16-8.334 3.898-8.503 8.487a8.825 8.825 0 0017.476 2.051c.176-.892-.523-1.719-1.432-1.719"
        />
        <path
          className="Logovariants__Path-sc-1y3h6v6-0 eFxjkg"
          d="M17.236 14.773a1.898 1.898 0 100 3.797 1.898 1.898 0 000-3.797"
        />
      </g>
      <path
        className="Logovariants__Path-sc-1y3h6v6-0 dTXGPN"
        d="M42.965 11.509c.162-.155.38-.234.656-.234s.494.081.656.243c.162.161.243.375.243.638v7.368c0 1.342-.357 2.355-1.07 3.037-.713.684-1.764 1.025-3.154 1.025-1.294 0-2.372-.245-3.234-.737l-.003-.001a.324.324 0 01-.133-.413l.338-.766a.325.325 0 01.453-.155l.01.005c.43.204.832.362 1.203.476.371.114.815.172 1.33.172 1.654 0 2.48-.833 2.48-2.5v-1.383a2.749 2.749 0 01-1.15 1.231c-.515.294-1.114.44-1.797.44-.767 0-1.45-.18-2.049-.538a3.625 3.625 0 01-1.392-1.528c-.33-.659-.495-1.42-.495-2.283 0-.862.168-1.623.503-2.282.336-.659.8-1.17 1.393-1.537.593-.364 1.273-.548 2.04-.548.671 0 1.26.144 1.77.432.51.287.896.695 1.16 1.222v-.755c0-.264.08-.473.242-.629zm-2.74 7.009c.778 0 1.39-.258 1.833-.773.443-.515.664-1.228.664-2.139 0-.898-.218-1.608-.656-2.129-.437-.521-1.05-.782-1.842-.782-.79 0-1.41.258-1.86.773-.449.515-.674 1.228-.674 2.138 0 .911.228 1.624.683 2.14.455.514 1.072.772 1.851.772zm12.802-6.147c.683.756 1.025 1.774 1.025 3.056 0 .479-.216.718-.647.718H47.85c.12 1.858 1.013 2.787 2.678 2.787.443 0 .827-.06 1.15-.18.324-.12.666-.276 1.025-.468.036-.024.135-.075.297-.152a.986.986 0 01.404-.117c.168 0 .305.066.413.198.108.131.162.3.162.503 0 .347-.216.64-.647.88a5.69 5.69 0 01-1.375.557 5.587 5.587 0 01-1.429.198c-1.39 0-2.486-.404-3.289-1.213-.803-.809-1.204-1.914-1.204-3.316 0-.898.177-1.695.53-2.39a3.893 3.893 0 011.492-1.617c.641-.384 1.369-.576 2.184-.576 1.174 0 2.103.378 2.785 1.132zm-4.42.864c-.42.443-.672 1.066-.756 1.745h4.637c-.036-.691-.242-1.317-.62-1.755-.377-.437-.907-.655-1.59-.655-.695 0-1.252.221-1.672.665zm15.35 1.545v5.301c0 .13-.105.234-.234.234h-1.348a.234.234 0 01-.234-.234V14.87c0-.743-.147-1.288-.44-1.635-.294-.348-.752-.522-1.375-.522-.73 0-1.318.228-1.761.683-.444.455-.665 1.066-.665 1.833v4.852c0 .13-.105.234-.234.234h-1.347a.234.234 0 01-.234-.234v-7.943a.81.81 0 01.26-.62.925.925 0 01.656-.243c.264 0 .474.079.63.234a.83.83 0 01.233.611v.39c0 .098.124.135.18.056a2.89 2.89 0 011.024-.914c.515-.275 1.096-.413 1.743-.413 2.097 0 3.145 1.18 3.145 3.54zm3.28-5.237a1.052 1.052 0 100-2.104 1.052 1.052 0 000 2.104zm.907 2.613c0-.287-.084-.506-.252-.656-.167-.15-.383-.225-.646-.225a.967.967 0 00-.656.225c-.174.15-.26.369-.26.656v7.959c0 .11.089.2.199.2h1.415a.2.2 0 00.2-.2v-7.96zm4.463-.71a6.868 6.868 0 011.636-.207c1.162 0 2.028.294 2.597.881.569.588.854 1.48.854 2.678v5.247a.27.27 0 01-.27.27H76.22a.27.27 0 01-.27-.27v-1.258a2.53 2.53 0 01-1.015 1.16c-.45.27-.974.404-1.573.404a3.569 3.569 0 01-1.581-.35 2.722 2.722 0 01-1.124-.98 2.537 2.537 0 01-.404-1.401c0-.635.165-1.136.494-1.501.33-.365.875-.626 1.636-.782.76-.156 1.806-.234 3.136-.234h.413v-.521c0-.67-.138-1.156-.413-1.455-.276-.3-.719-.45-1.33-.45-.42 0-.815.054-1.186.162a8.936 8.936 0 00-1.222.467c-.324.18-.552.27-.683.27a.553.553 0 01-.44-.198.742.742 0 01-.171-.503.78.78 0 01.153-.477c.101-.137.266-.272.494-.404.419-.228.91-.41 1.473-.548zm2.697 6.883c.418-.45.628-1.027.628-1.734v-.467h-.323c-.935 0-1.654.042-2.157.125-.503.084-.862.225-1.078.423-.216.198-.324.482-.324.854 0 .43.156.784.468 1.06.311.276.7.413 1.168.413.659 0 1.198-.224 1.617-.674zm6.314-9.494v11.218a.262.262 0 01-.262.262h-1.292a.262.262 0 01-.261-.262V8.835c0-.288.084-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm3.916 0v11.218a.262.262 0 01-.262.262H83.98a.262.262 0 01-.261-.262V8.835c0-.288.083-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm10.42 3.25c0 .119-.025.233-.072.34l-5.33 11.315a.845.845 0 01-.316.386.79.79 0 01-.44.135.89.89 0 01-.584-.216.671.671 0 01-.26-.54c0-.095.03-.215.09-.358l1.574-3.353-3.469-7.369a.711.711 0 01-.072-.323c0-.228.096-.42.288-.575a1 1 0 01.647-.234c.36 0 .617.168.772.504l2.786 6.182 2.768-6.164a.786.786 0 01.755-.522c.227 0 .428.079.602.234.173.156.26.342.26.557z"
        fill="#000F33"
      />
      <defs>
        <linearGradient
          id="f"
          x1="12.273"
          x2="20.739"
          y1="11.576"
          y2="15.313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2B344" offset="0" />
          <stop stopColor="#F05480" offset="1" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="26.631"
          x2="26.631"
          y1="20.482"
          y2="11.578"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B156CD" offset="0" />
          <stop stopColor="#F05480" offset="1" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="20.817"
          x2="11.74"
          y1="15.429"
          y2="20.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B157CE" offset="0" />
          <stop stopColor="#5DA5FB" offset="1" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="5.126"
          x2="13.275"
          y1="24.357"
          y2="27.954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#74E6A7" offset="0" />
          <stop stopColor="#5DA5FB" offset="1" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="3.023"
          x2="3.023"
          y1="11.232"
          y2="20.146"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8ED5B" offset="0" />
          <stop stopColor="#74E6A7" offset="1" />
        </linearGradient>
        <linearGradient
          id="a"
          x1="9.4"
          x2="17.2"
          y1="15.712"
          y2="12.195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8ED5B" offset="0" />
          <stop stopColor="#F2B344" offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LogoGenially;
